$(document).ready(function () {
  new WOW().init();
});

// ========================== Add Common-Home Class On Body Tag ==========================
document.addEventListener("DOMContentLoaded", function () {
  var slideshowElement = document.getElementById("TB-slider-cms");
  if (slideshowElement) {
    document.body.classList.add("common-home");
  }
});

// ========================== Circular text ==========================
document.addEventListener("DOMContentLoaded", function () {
  const text = document.querySelector(".text");
  if (text) {
    text.innerHTML = text.innerText
      .split("")
      .map(
        (char, i) =>
          `<span style="transform:rotate(${i * 10.3}deg)">${char}</span>`
      )
      .join("");
  }
});

// ========================== Parallax Left IMG animation mousemove ==========================
document.addEventListener("DOMContentLoaded", function () {
  const image = document.querySelector(".parallax-left-img img");

  image.addEventListener("mousemove", (event) => {
    const { top, bottom, left, right } = event.target.getBoundingClientRect();

    const middleX = (right - left) / 2;
    const middleY = (bottom - top) / 2;

    const clientX = event.clientX;
    const clientY = event.clientY;

    const offsetX = (clientX - middleX) / middleX;
    const offsetY = (middleY - clientY) / middleY;

    event.target.style.transform = `perspective(1000px) rotateY(${
      offsetX * 5
    }deg) rotateX(${offsetY * 5}deg) scale3d(1, 1, 1)`;
  });
});

// ========================== Video Banner ==========================
document.addEventListener("DOMContentLoaded", function () {
  const videoWrappers = document.querySelectorAll(".video-wrapper");

  videoWrappers.forEach((wrapper) => {
    const banner = wrapper.querySelector(".video-banner");
    const playButton = wrapper.querySelector(".play-button");
    const video = wrapper.querySelector(".short-video");

    wrapper.addEventListener("click", function () {
      if (video.style.display === "none") {
        // Show video and play
        banner.style.display = "none";
        playButton.style.display = "none";
        video.style.display = "block";
        video.play();
      } else {
        // Stop video and show banner
        video.pause();
        video.style.display = "none";
        banner.style.display = "block";
        playButton.style.display = "block";
      }
    });

    // Stop video and reset when it ends
    video.addEventListener("ended", function () {
      video.style.display = "none";
      banner.style.display = "block";
      playButton.style.display = "block";
    });
  });
});

// ========================== Add Common-Home Class On Body Tag ==========================
document.addEventListener("DOMContentLoaded", function () {
  var slideshowElement = document.getElementById("tb-slideshow");
  if (slideshowElement) {
    document.body.classList.add("common-home");
  }
});

// ========================== BACK TO TOP ==========================
$(window).scroll(function () {
  if ($(this).scrollTop() >= 50) {
    $("#return-to-top").fadeIn(200);
  } else {
    $("#return-to-top").fadeOut(200);
  }
});
$("#return-to-top").click(function () {
  $("body,html").animate(
    {
      scrollTop: 0,
    },
    500
  );
});

// ========================== MENU-CLICK HIDE MENU DROPDOWN ==========================
$(document).ready(function () {
  $(".list-menu__item").on("click", function () {
    $("#Details-menu-drawer-container").removeAttr("open");
    $(".header__icon").attr("aria-expanded", "false");
    $("body").removeClass("overflow-hidden-tablet");
    $(".menu-opening").removeClass("menu-opening");
  });
});

// ========================== OWL-CAROUSEL ==========================
$(document).ready(function () {
  $("#TB-slider-cms .owl-carousel").owlCarousel({
    loop: false,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayHoverPause: true,
    items: 1,
    animateOut: "fadeOut",
  });

  $("#TB-Category-cms .owl-carousel").owlCarousel({
    loop: true,
    dots: false,
    nav: true,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      576: { items: 3 },
      768: { items: 3 },
      992: { items: 4 },
    },
  });

  $("#TB-Video-cms .owl-carousel").owlCarousel({
    loop: false,
    margin: 20,
    nav: false,
    dots: false,
    responsive: {
      0: { items: 1 },
      481: { items: 2 },
      768: { items: 3 },
      992: { items: 4, touchDrag: true, mouseDrag: true },
      1300: { items: 5, touchDrag: false, mouseDrag: false },
    },
  });

  $("#TB-Testimonial-cms .owl-carousel").owlCarousel({
    loop: true,
    center: true,
    margin: 24,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    nav: false,
    dots: true,
    responsive: {
      0: { items: 1, center: false },
      576: { items: 2 },
      768: { items: 2 },
      992: { items: 3 },
      1200: { items: 4 },
      1800: { items: 6 },
    },
  });

  $("#TB-banner-cms .owl-carousel").owlCarousel({
    loop: false,
    dots: false,
    nav: true,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      481: { items: 2 },
      576: { items: 3 },
      992: { items: 5 },
    },
  });
});

// ========================== FOOTER TOGGLE ==========================
function footerToggle() {
  if ($(window).width() < 992) {
    $(".tb-footer-center .footer-column h5").addClass("toggle");
    $(".tb-footer-center .footer-column h5.toggle").unbind("click");
    var Accordions = function (el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;
      var link = this.el.find(".toggle");
      link.on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
    };
    Accordions.prototype.dropdown = function (e) {
      var $el = e.data.el;
      ($this = $(this)), ($next = $this.next());
      $next.slideToggle();
      $this.parent().toggleClass("active");
      if (!e.data.multiple) {
        $el
          .find(".tb-footer-center .footer-column")
          .not($next)
          .slideUp()
          .parent()
          .removeClass("active");
      }
    };
    var accordions = new Accordions(
      $(".tb-footer-center .footer-column"),
      false
    );
  } else {
    $(".tb-footer-center .footer-column h5.toggle").unbind("click");
    $(".tb-footer-center .footer-column h5").removeClass("toggle");
  }
}
$(document).ready(function () {
  footerToggle();
});
$(window).resize(function () {
  footerToggle();
});

// ========================== INSPECT CLOSE ==========================
// Prevent Developer Tools, Right-Click, and Restricted Shortcuts
document.addEventListener(
  "keydown",
  function (event) {
    if (
      event.keyCode === 123 || // F12
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 67 || event.keyCode === 99)) || // Ctrl+Shift+C or c
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 73 || event.keyCode === 105)) || // Ctrl+Shift+I or i
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 74 || event.keyCode === 106)) || // Ctrl+Shift+J or j
      (event.ctrlKey && event.keyCode === 85) || // Ctrl+U
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 77 || event.keyCode === 109)) || // Ctrl+Shift+M or m
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 69 || event.keyCode === 101)) || // Ctrl+Shift+E or e
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 84 || event.keyCode === 116)) || // Ctrl+Shift+T or t
      (event.ctrlKey &&
        event.shiftKey &&
        (event.keyCode === 88 || event.keyCode === 120)) || // Ctrl+Shift+X or x
      (event.ctrlKey && event.altKey && event.keyCode === 83) || // Ctrl+Alt+S
      (event.metaKey && event.shiftKey && event.keyCode === 80) || // Cmd+Shift+P (Mac)
      (event.ctrlKey && event.keyCode === 83) || // Ctrl+S
      (event.metaKey && event.keyCode === 83) // Cmd+S (Mac)
    ) {
      event.preventDefault();
    }
  },
  false
);

// Prevent context menu
document.addEventListener(
  "contextmenu",
  function (event) {
    event.preventDefault();
  },
  false
);

// Prevent mouse actions
document.addEventListener(
  "mousedown",
  function (event) {
    if (
      event.button === 2 || // Right-click
      (event.ctrlKey && event.button === 0) || // Ctrl+Left-click
      (event.metaKey && event.button === 0) // Cmd+Left-click on Mac
    ) {
      event.preventDefault();
    }
  },
  false
);
